import { render, staticRenderFns } from "./SuperAdminProfile.vue?vue&type=template&id=789b810a&scoped=true&"
import script from "./SuperAdminProfile.vue?vue&type=script&lang=js&"
export * from "./SuperAdminProfile.vue?vue&type=script&lang=js&"
import style0 from "./SuperAdminProfile.vue?vue&type=style&index=0&id=789b810a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789b810a",
  null
  
)

export default component.exports